import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { purchaseOrdersService } from "../../api_client";
import { AppRoutes } from "../../../common/routes/app_routes";
import { showErrorToast, showSuccessToast } from "../../../utils/toasts";
import { handleAxiosError } from "../../../common/error_handling";

export function useMarkPurchaseOrderDelivered() {
    const [ isLoading, setIsLoading ] = useState(false);
    const navigate = useNavigate();

    const markDelivered = async (
        id: number,
        imageFile: File,
    ) => {
        setIsLoading(true);
        try {
            await purchaseOrdersService.markPurchaseOrderDelivered(
                id,
                imageFile,
            );

            showSuccessToast("Purchase order marked as delivered successfully!");
            navigate(`${AppRoutes.PURCHASE_ORDERS}/${id}`);
        } catch (error) {
            const { message } = handleAxiosError(error);
            showErrorToast(
                message || "Failed to mark purchase order as delivered"
            );
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    return { markDelivered, isLoading };
}



